export default __webpack_public_path__ + "static/media/contact.17da4eeb.svg";